<template>
    <div>
        <div class="row mb-4">
            <div class="col-7">
                <b-button variant="light" :disabled="!libraryLoaded" size="sm" @click="setExpandAll">{{ t.__('Rozwiń wszystko') }} </b-button>
                <b-button variant="light" size="sm" @click="setCollapseAll">{{ t.__('Zwiń wszystko') }}</b-button>
                <b-button variant="primary" size="sm" @click="enableOrderManagementState()"
                    v-show="repo === 'dev' && !orderManagementState">{{ t.__('Zarządzaj kolejnością') }}</b-button>
                <b-button variant="success" size="sm" @click="orderManagementSave()"
                    v-show="repo === 'dev' && orderManagementState">{{ t.__('Zapisz') }}</b-button>
                <b-button variant="warning" size="sm" @click="orderManagementCancel()"
                    v-show="repo === 'dev' && orderManagementState">{{ t.__('Anuluj') }}</b-button>
            </div>
            <div class="col-5 text-right">
                <b-button variant="primary" size="sm" v-if="repo === 'dev' && !orderManagementState"
                    @click="showManageTagsModal">Zarządzaj tagami gier</b-button>
                <b-button variant="primary" size="sm" v-if="repo === 'dev' && !orderManagementState"
                    @click="showGameAssignmentManagementModal">Zarządzaj przypisaniem gier</b-button>
            </div>
        </div>

        <div class="game-library-wrapper">
            <div class="game-library mt-1">

                <game-library-area v-for="(area, index) in library" :key="index" :repo="repo" :area="area"
                    :library.sync="library" :order-management-state="orderManagementState" :expand-all="expandAll">
                    <template v-if="props.areaCreated" slot-scope="props">
                        <game-library-package v-for="(package_, index) in area.packages" :key="index" :repo="repo"
                            :package_="package_" :library.sync="library" :area-expanded="props.areaExpanded"
                            :order-management-state="orderManagementState" :package-expanded="props.packageExpanded"
                            :expand-all="expandAll" :library-loaded="libraryLoaded">
                            <template v-if="props.packageCreated" slot-scope="props">
                                <game-library-set v-for="(set, index) in package_.sets" :key="index" :repo="repo"
                                    :set="set" :library.sync="library" :package-expanded="props.packageExpanded"
                                    :order-management-state="orderManagementState" :expand-all="expandAll"
                                    :library-loaded="libraryLoaded">
                                    <template v-if="props.setCreated" slot-scope="props">
                                        <game-library-game v-for="(game, index) in set.games" :key="index" :repo="repo"
                                            :game="game" :library.sync="library" :set-expanded="props.setExpanded"
                                            :order-management-state="orderManagementState"></game-library-game>
                                    </template>
                                </game-library-set>
                            </template>
                        </game-library-package>
                    </template>
                </game-library-area>

                <div class="element top-element yellow" v-bind:class="{ 'repo-dev': repo === 'dev' }">
                    <div class="element-heading">
                        <div class="element-text"
                            v-bind:class="{ 'disabled': (repo !== 'dev' || orderManagementState) }">
                            <a href="#" class="text-primary" @click="addArea">Dodaj obszar</a>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="my-3">
            <div class="caption-title">Legenda:</div>
            <div class="caption-color-block yellow">Obszar</div>
            <div class="caption-color-block green">Pakiet</div>
            <div class="caption-color-block blue">Zestaw</div>
            <div class="caption-color-block white">Gra</div>
        </div>

        <div class="menu-block d-table w-100 mt-4">
            <div class="d-table-row">
                <div class="d-table-cell menu-title">Menu</div>
                <div class="d-table-cell menu-dates">
                    <div>
                        <small>Ostatnia aktualizacja plików źródłowych: {{ menuFilesUpdateDate }}</small>
                    </div>
                    <div>
                        <small>Ostatnia aktualizacja tłumaczeń: {{ menuTranslationsUpdateDate }}</small>
                    </div>
                    <div v-if="repo !== 'prod'">
                        <small>Ostatnie zatwierdzenie: {{ menuApproveDate }}</small>
                    </div>
                </div>
                <div class="d-table-cell text-right menu-buttons">
                    <div class="buttons-row">
                        <b-button variant="success" size="xs" @click="approveMenu" v-if="repo !== 'prod'"
                            :disabled="!Boolean(menu.need_approve)">
                            Zatwierdź
                        </b-button>
                        <b-button variant="info" size="xs" @click="showMenuChangelog">
                            Changelog
                        </b-button>
                    </div>
                </div>
            </div>
        </div>

        <table class="table table-bordered actions-table mt-5">
            <thead>
                <tr>
                    <th>
                        <strong>Aktualizuj lokalną kopię repozytorium tłumaczeń</strong>
                    </th>
                    <th>
                        <strong>Aktualizuj pliki repozytorium deweloperskiego</strong>
                    </th>
                    <th>
                        <strong>Aktualizuj zdalne repozytorium tłumaczeń i Weblate</strong>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <p>Aktualizuj lokalną kopię repozytorium tłumaczeń wykonując <code>git pull</code> ze zdalnego
                            repozytorium.</p>
                        <p>Ifpanel korzysta z lokalnej kopii repozytorium, którego źródło jest na zdalnym serwerze
                            współdzielonym z Weblate. Ta akcja zapewnia pracę na najnowszej wersji tłumaczeń.</p>
                        <!--                        <p>W ramach operacji aktualizowany jest również postęp tłumaczeń pakietów </p>-->
                        <p class="mb-0">Poniżej znajduje się data ostatniego commita w lokalnej kopii repozytorium
                            tłumaczeń.
                        </p>
                    </td>
                    <td>
                        <p>Zaktualizuj pliki konfiguracyjne elementów biblioteki gier w repozytorium deweloperskim.</p>
                        <p>W oparciu o konfigurację w Ifpanelu, wygnerowane zostaną nowe pliki <code>.cfg</code>, dodane
                            ikony i
                            skopiowane tłumaczenia z lokalnej kopii repozytorium tłumaczeń.</p>
                        <p class="mb-0">Pliki repozytorium deweloperskiego są edytowane tylko podczas tej akcji. Przed
                            zatwierdzeniem elementów do repozytorium testowego, upewnij się, że zmiany w Bibliotece Gier
                            są
                            odzwierciedlone w plikach repozytorium. Podczas zatwierdzania elementu uwzględniany jest
                            aktualny
                            stan plików konfiguracyjnych.</p>
                    </td>
                    <td>
                        <ol>
                            <li>Zaktualizuj lokalną kopię repozytorium tłumaczeń.</li>
                            <li>Skopiuj nazwy i opisy elementów biblioteki gier do bazy danych Ifpanelu z plików
                                tłumaczeń,
                                używając domyślnych języków.</li>
                            <li>Stwórz bazowe pliki tłumaczeń dla obszarów i pakietów w ich domyślnych językach. Dodaj
                                także
                                bazowy plik tłumaczeń dla tagów gier (PL).</li>
                            <li>Wyślij zmiany do zdalnego repozytorium tłumaczeń.</li>
                            <li>Aktualizuj projekty i komponenty w Weblate na podstawie zdalnego repozytorium.</li>
                        </ol>
                    </td>
                </tr>
                <tr>
                    <td>Ostatni commit: {{ langDownRepositoryUpdateDate ?? '---' }}</td>
                    <td>Ostatnia aktualizacja: {{ devRepositoryPublicationDate ?? '---' }}</td>
                    <td>Ostatnia aktualizacja: {{ langRepositoryUpdateDate ?? '---' }}</td>
                </tr>
                <tr>
                    <td>
                        <b-button variant="info" size="sm" @click="synchronizeLangRepository">Wykonaj</b-button>
                    </td>
                    <td>
                        <b-button variant="warning" size="sm" @click="updateDevRepository">Wykonaj</b-button>
                    </td>
                    <td>
                        <b-button variant="primary" size="sm" @click="updateRemoteLangRepository">Wykonaj</b-button>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- MODALS -->

        <game-library-area-modal :repo="repo" :library.sync="library"></game-library-area-modal>

        <game-library-package-modal :repo="repo" :library.sync="library"
            :area-locations="locations.areas"></game-library-package-modal>

        <game-library-set-modal :repo="repo" :library.sync="library"
            :package-locations="locations.packages"></game-library-set-modal>

        <game-library-game-modal v-if="libraryLoaded" repo="repo" :library.sync="library"
            :set-locations="locations.sets" :editors="gameEditors"></game-library-game-modal>

        <game-library-assign-games-modal v-if="locations.sets.length > 0" :repo="repo" :library.sync="library"
            :set-locations="locations.sets"></game-library-assign-games-modal>

        <b-modal id="select-games-to-assign-modal" title="Wybierz grę lub gry do przypisania" :hide-footer="true"
            :ok-disabled="true" cancel-title="Anuluj" @hidden="selectGameToAssignModalHandleHide">
            <div class="mb-3 text-right">
                <button class="btn btn-primary btn-sm" @click="assignManyGamesModal"
                    :disabled="selectedGamesToAssignModal.length === 0">Przypisz zaznaczone</button>
            </div>
            <div class="not-assigned-games">
                <div class="not-assigned-game" v-if="notAssignedGames.length > 0"
                    v-for="(notAssignedGame, index) in notAssignedGames">
                    <div class="custom-control custom-checkbox d-inline-block">
                        <input type="checkbox" class="custom-control-input"
                            v-bind:id="'not-assigned-game-' + index + '-modal'" v-model="selectedGamesToAssignModal"
                            :value="notAssignedGame">
                        <label class="custom-control-label"
                            v-bind:for="'not-assigned-game-' + index + '-modal'"></label>
                        <label class="checkbox-text" v-bind:for="'not-assigned-game-' + index + '-modal'"
                            title="notAssignedGame">{{ notAssignedGame }}</label>
                    </div>
                    <a href="javascript:void(0);" class="text-primary assign" @click="assignGameModal(notAssignedGame)"
                        title="Przypisz"><i class="fa fa-plus-square-o"></i></a>
                </div>
                <div class="not-assigned-game text-center" v-if="notAssignedGames.length === 0">
                    <span><i>Brak nieprzypisanych gier</i></span>
                </div>
            </div>
        </b-modal>

        <game-library-move-modal :repo="repo" :all-locations="locations"></game-library-move-modal>

        <b-modal id="approve-element-modal"
            :title="'Zatwierdź element do repozytorium ' + (repo === 'dev' ? 'testowego' : 'produkcyjnego')"
            ok-title="Zatwierdź" cancel-title="Anuluj" ok-variant="success" no-close-on-backdrop
            @ok="approveElementModalHandleOk" @hidden="approveElementModalHandleHide">
            <div v-if="elementToApprove">
                <div>Element: {{ elementToApprove.display_name }} ({{ elementToApprove.type === 'area' ? 'obszar' :
                    (elementToApprove.type === 'package' ? 'pakiet' : (elementToApprove.type === 'game' ? 'gra' :
                        (elementToApprove.type === 'menu' ? 'menu' : '---'))) }})</div>
                <br>
                <div style="font-size: 0.875rem;">Ostatnie zatwierdzenie: {{ elementToApprove.approved_at }}</div>
                <br>
                <div v-if="elementToApprove.files_were_updated_since_last_approve" style="font-size: 0.875rem;">Piki
                    zostały
                    zaktualizowane ({{ elementToApprove.files_updated_at }})</div>
                <div v-if="elementToApprove.config_was_updated_since_last_approve" style="font-size: 0.875rem;">
                    Konfiguracja
                    została zaktualizowana ({{ elementToApprove.updated_at }})</div>
                <div v-if="elementToApprove.translations_were_updated_since_last_approve" style="font-size: 0.875rem;">
                    Tłumaczenia zostały zaktualizowane ({{ elementToApprove.translations_updated_at }})</div>
                <br>
                <template v-if="elementToApprove.type === 'game'">
                    <div class="mb-2" style="font-size: 0.875rem;">Changelog</div>
                    <pre>{{ elementToApprove.changelog }}</pre>
                </template>
            </div>
        </b-modal>

        <game-library-element-changelog-modal :repo="repo"></game-library-element-changelog-modal>

        <game-library-manage-tags-modal></game-library-manage-tags-modal>

        <game-library-approve-game-modal></game-library-approve-game-modal>

        <game-library-approve-game-translations-modal></game-library-approve-game-translations-modal>

        <game-library-approve-menu-modal></game-library-approve-menu-modal>

        <game-library-approve-menu-translations-modal></game-library-approve-menu-translations-modal>

        <b-modal size="xl" id="game-assignment-management-modal" title="Zarządzaj przypisaniem gier" ok-only
            ok-title="Zamknij" ok-variant="secondary">

            <b-button variant="primary" size="sm" class="mb-4" :disabled="selectedGamesToAssign.length === 0"
                @click="assignManyGames">
                Przypisz zaznaczone
            </b-button>

            <div class="row">

                <div class="col-4">
                    <div>
                        <h5 class="mb-3">Nieprzypisane gry ({{ notAssignedGames.length }})</h5>
                        <div class="not-assigned-games">
                            <div class="not-assigned-game" v-if="notAssignedGames.length > 0"
                                v-for="(notAssignedGame, index) in notAssignedGames">
                                <div class="custom-control custom-checkbox d-inline-block">
                                    <input type="checkbox" class="custom-control-input"
                                        v-bind:id="'not-assigned-game-' + index" v-model="selectedGamesToAssign"
                                        :value="notAssignedGame">
                                    <label class="custom-control-label"
                                        v-bind:for="'not-assigned-game-' + index"></label>
                                    <label class="checkbox-text" v-bind:for="'not-assigned-game-' + index"
                                        :title="notAssignedGame">{{ notAssignedGame }}</label>
                                </div>
                                <a href="javascript:void(0);" class="text-primary assign"
                                    @click="assignGame(notAssignedGame)" title="Przypisz"><i
                                        class="fa fa-plus-square-o"></i></a>
                                <span>&nbsp;&nbsp;</span>
                                <a href="javascript:void(0);" class="text-warning ignore"
                                    @click="addGameToIgnored(notAssignedGame)" title="Ignoruj"><i
                                        class="fa fa-minus-square-o"></i></a>
                            </div>
                            <div class="not-assigned-game text-center" v-if="notAssignedGames.length === 0">
                                <span><i>Brak nieprzypisanych gier</i></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div>
                        <h5 class="mb-3">Przypisane gry ({{ assignedGames.length }})</h5>
                        <div class="assigned-games">
                            <div class="assigned-game" v-bind:class="{ 'disabled': orderManagementState }"
                                v-if="assignedGames.length > 0" v-for="(assignedGame, index) in assignedGames">
                                <div class="custom-control custom-checkbox d-inline-block">
                                    <input type="checkbox" class="custom-control-input"
                                        v-bind:id="'assigned-game-' + index" v-model="selectedGamesToAssign"
                                        :value="assignedGame">
                                    <label class="custom-control-label" v-bind:for="'assigned-game-' + index"></label>
                                    <label class="checkbox-text" v-bind:for="'assigned-game-' + index"
                                        :title="assignedGame">{{
                                            assignedGame }}</label>
                                </div>
                                <a href="javascript:void(0);" class="text-primary assign"
                                    @click="assignGame(assignedGame)" title="Przypisz"><i
                                        class="fa fa-plus-square-o"></i></a>
                            </div>
                            <div class="not-assigned-game text-center" v-if="assignedGames.length === 0">
                                <span><i>Brak przypisanych gier</i></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-4">
                    <div>
                        <h5 class="mb-3">Ignorowane gry ({{ ignoredGames.length }})</h5>
                        <div class="ignored-games">
                            <div class="ignored-game" v-bind:class="{ 'disabled': orderManagementState }"
                                v-if="ignoredGames.length > 0" v-for="(ignoredGame, index) in ignoredGames">
                                <div class="d-inline-block ignored-game-text"
                                    :title="ignoredGame.input_identification_name">{{
                                        ignoredGame.input_identification_name }}</div>
                                <a href="javascript:void(0);" class="text-primary restore"
                                    @click="removeGameFromIgnored(ignoredGame.input_identification_name)"
                                    title="Przywróć"><i class="fa fa-undo"></i></a>
                            </div>
                            <div class="ignored-game text-center" v-if="ignoredGames.length === 0">
                                <span><i>Brak ignorowanych gier</i></span>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </b-modal>

    </div>
</template>

<script>
export default {

    name: 'GameLibrary',

    props: [
        'repo',
        'libraryInput',
        'menuInput',
        'repoUpdateInput'

    ],

    data() {
        return {
            eventHub: window.eventHub,
            library: [],
            rawGames: [],
            ignoredGames: [],
            menu: {},
            repoUpdate: {},
            orderManagementState: false,
            orderManagementLibraryCopy: [],
            notAssignedGamesExpand: false,
            assignedGamesExpand: false,
            ignoredGamesExpand: false,
            selectedGamesToAssign: [],
            selectedGamesToAssignModal: [],
            assignGameSetId: null,
            elementToApprove: null,
            expandAll: false,
            gameEditors: null,
            libraryLoaded: false
        }
    },
    computed: {
        locations: function () {
            let locations = {
                areas: [],
                packages: [],
                sets: []
            };
            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    let location = {
                        text: area.display_name,
                        id: area.id
                    };
                    if (!locations.areas.includes(location)) {
                        locations.areas.push(location);
                    }
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            let location = {
                                text: area.display_name + '/' + package_.display_name,
                                id: package_.id
                            };
                            if (!locations.packages.includes(location)) {
                                locations.packages.push(location);
                            }
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    let location = {
                                        text: area.display_name + '/' + package_.display_name + '/' + set.display_name,
                                        id: set.id
                                    };
                                    if (!locations.sets.includes(location)) {
                                        locations.sets.push(location);
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return locations;
        },
        notAssignedGames: function () {
            let notAssignedGames = this.rawGames.map((element) => {
                return element.input_identification_name;
            });
            this.ignoredGames.forEach((ignoredGame) => {
                let index = notAssignedGames.indexOf(ignoredGame.input_identification_name);
                if (index !== -1) {
                    notAssignedGames.splice(index, 1);
                }
            });
            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    if (set.games && set.games.length) {
                                        set.games.forEach((game) => {
                                            let index = notAssignedGames.indexOf(game.input_identification_name);
                                            if (index !== -1) {
                                                notAssignedGames.splice(index, 1);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return notAssignedGames;
        },
        assignedGames: function () {
            let assignedGames = [];
            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    if (set.games && set.games.length) {
                                        set.games.forEach((game) => {
                                            if (assignedGames.indexOf(game.input_identification_name) === -1) {
                                                assignedGames.push(game.input_identification_name);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return assignedGames;
        },
        changeSinceRepoUpdate: function () {
            let changeSinceRepoUpdate = false;
            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    if (Date.parse(area.updated_at.replace(new RegExp('-', 'g'), '/')) > Date.parse(this.repoUpdate.prod.updated_at.replace(new RegExp('-', 'g'), '/'))) {
                        changeSinceRepoUpdate = true;
                        return;
                    }
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            if (Date.parse(package_.updated_at.replace(new RegExp('-', 'g'), '/')) > Date.parse(this.repoUpdate.prod.updated_at.replace(new RegExp('-', 'g'), '/'))) {
                                changeSinceRepoUpdate = true;
                                return;
                            }
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    if (Date.parse(set.updated_at.replace(new RegExp('-', 'g'), '/')) > Date.parse(this.repoUpdate.prod.updated_at.replace(new RegExp('-', 'g'), '/'))) {
                                        changeSinceRepoUpdate = true;
                                        return;
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return changeSinceRepoUpdate;
        },
        updatedGamesSinceRepoUpdate: function () {
            let updatedGamesSinceRepoUpdate = [];
            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    if (set.games && set.games.length) {
                                        set.games.forEach((game) => {
                                            if (Date.parse(game.updated_at.replace(new RegExp('-', 'g'), '/')) > Date.parse(this.repoUpdate.prod.updated_at.replace(new RegExp('-', 'g'), '/'))) {
                                                updatedGamesSinceRepoUpdate.push(game.output_identification_name);
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
            return updatedGamesSinceRepoUpdate;
        },
        devRepositoryPublicationDate: function () {
            return (new Date(this.repoUpdate.dev.updated_at)).toLocaleString();
        },
        prodRepositoryUpdateDate: function () {
            return (new Date(this.repoUpdate.prod.updated_at)).toLocaleString()
        },
        langDownRepositoryUpdateDate: function () {
            if (this.repoUpdate.lang_down === null) {
                return null;
            }
            return (new Date(this.repoUpdate.lang_down * 1000)).toLocaleString();
        },
        langRepositoryUpdateDate: function () {
            return (new Date(this.repoUpdate.lang.updated_at)).toLocaleString();
        },
        isDevRepoUpdateDateOlderThanLangRepoDownDate: function () {
            if (this.repoUpdate.lang_down === null) {
                return false;
            }
            return (new Date(this.repoUpdate.lang_down * 1000)) > (new Date(this.repoUpdate.dev.updated_at.replace(new RegExp('-', 'g'), '/')));
        },
        menuFilesUpdateDate: function () {
            return (new Date(this.menu.files_updated_at)).toLocaleString();
        },
        menuTranslationsUpdateDate: function () {
            return (new Date(this.menu.translations_updated_at)).toLocaleString();
        },
        menuApproveDate: function () {
            return (new Date(this.menu.approved_at)).toLocaleString();
        }
    },

    beforeMount() {
        this.library = this.libraryInput;
        this.menu = this.menuInput;
        this.repoUpdate = this.repoUpdateInput;
    },

    mounted() {

        this.eventHub.$on('library-requested-while-not-loaded', (id) => {
            this.getElement(this.library, id)
        });

        axios.get(route('game::game-library.get-full-library', {
            repo: this.repo
        }))
            .then(response => {
                this.rawGames = response.data["rawGames"];
                this.ignoredGames = response.data["ignoredGames"];
                this.gameEditors = response.data["gameEditors"];
                this.library = response.data["libraryInput"];
                this.libraryLoaded = true;
            })
            .catch(error => {
                console.log(error);
                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
            });

        // Game library was updated, refresh locations and not assigned games
        this.eventHub.$on('game-library-updated', (library = null) => {
            if (library) {
                this.library = library;
            }
            this.selectedGamesToAssign = [];
            this.selectedGamesToAssignModal = [];

            this.$forceUpdate(); // ? check if necessary
        });

        this.eventHub.$on('game-library-menu-updated', (menu = null) => {
            if (menu) {
                this.menu = menu;
            }
        });

        this.eventHub.$on('game-library-assign-game-in-set', (setId) => {
            this.assignGameSetId = setId;
            this.$bvModal.show('select-games-to-assign-modal');
        });

        this.eventHub.$on('game-library-approve-element', (type, element) => {
            this.eventHub.$emit('processing-start');
            this.elementToApprove = {
                type: type,
                id: element.id,
                display_name: element.display_name,
                updated_at: element.updated_at,
                approved_at: element.approved_at.toString(),
                files_updated_at: element.files_updated_at,
                translations_updated_at: element.translations_updated_at,
                files_were_updated_since_last_approve: element.files_were_updated_since_last_approve,
                config_was_updated_since_last_approve: element.config_was_updated_since_last_approve,
                translations_were_updated_since_last_approve: element.translations_were_updated_since_last_approve,
                changelog: null
            };
            console.log(this.elementToApprove);
            if (type === 'game') {
                axios.get(route('game::game-library.get-game-changelog', {
                    repo: this.repo,
                    id: this.elementToApprove.id
                }))
                    .then(response => {
                        this.elementToApprove.changelog = response.data.data.changelog;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('approve-element-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    });
            } else if (type === 'menu') {
                axios.get(route('game::game-library.get-menu-changelog', {
                    repo: this.repo
                }))
                    .then(response => {
                        this.elementToApprove.changelog = response.data.data.changelog;
                        this.eventHub.$emit('processing-finish');
                        this.$bvModal.show('approve-element-modal');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    });
            } else {
                this.eventHub.$emit('processing-finish');
                this.$bvModal.show('approve-element-modal');
            }
        });

    },

    methods: {

        getElement(obj, id) {
            obj.forEach((element) => {
                let obj = element['packages']
                obj.forEach((my_package) => {
                    if (my_package.id == id) {
                        axios.get(route('game::game-library.get-missing-sets', {
                            repo: this.repo,
                            id: id
                        }))
                            .then(response => {
                                let sets = response.data['sets']
                                Vue.set(my_package, 'sets', [])
                                sets.forEach((set, index) => {
                                    Vue.set(my_package['sets'], index, set)
                                })
                                this.eventHub.$emit('library-requested-loaded');
                            })
                            .catch(error => {
                                console.log(error);
                                this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                            });


                    }
                })
            })
        },

        // getElement(obj, nest_array, id, key) {
        //     for (let i = 0; i < obj.length; i++) {
        //         if (key < nest_array.length) {
        //             let my_key = nest_array[key]
        //             let my_obj = obj[i][my_key]
        //             this.getElement(my_obj, nest_array, id, key + 1)
        //         }
        //         if (key == nest_array.length && obj[i].id == id) {
        //             // this.eventHub.$emit('processing-start');
        //             axios.get(route('game::game-library.get-missing-element', {
        //                 repo: this.repo,
        //                 type: nest_array[key-1],
        //                 id: id
        //             }))
        //                 .then(response => {
        //                     let set = response.data['set']
        //                     Vue.set(obj[i],'sets',[])
        //                     set.forEach((element,index) => {
        //                         Vue.set(obj[i]['sets'], index, element)
        //                     })
        //                     this.eventHub.$emit('processing-finish');
        //                 })
        //                 .catch(error => {
        //                     this.eventHub.$emit('processing-finish');
        //                     console.log(error);
        //                     this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
        //                 });


        //         }
        //     }
        // },

        setCollapseAll() {
            this.eventHub.$emit('game-library-collapse-all');
        },

        setExpandAll() {
            if (this.expandAll) {
                this.eventHub.$emit('game-library-expand-all');
            } else {
                this.expandAll = true
            }
        },

        enableOrderManagementState() {
            this.orderManagementLibraryCopy = [...this.library];
            this.orderManagementState = true;
        },

        orderManagementSave() {
            let orderValues = {
                areas: [],
                packages: [],
                sets: [],
                games: []
            };

            if (this.library && this.library.length) {
                this.library.forEach((area) => {
                    orderValues.areas.push({
                        id: area.id,
                        order: area.number_in_order
                    });
                    if (area.packages && area.packages.length) {
                        area.packages.forEach((package_) => {
                            orderValues.packages.push({
                                id: package_.id,
                                order: package_.number_in_order
                            });
                            if (package_.sets && package_.sets.length) {
                                package_.sets.forEach((set) => {
                                    orderValues.sets.push({
                                        id: set.id,
                                        order: set.number_in_order
                                    });
                                    if (set.games && set.games.length) {
                                        set.games.forEach((game) => {
                                            orderValues.games.push({
                                                id: game.id,
                                                order: game.number_in_order
                                            });
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }

            this.eventHub.$emit('processing-start');
            axios.put(route('game::game-library.update-order', {
                repo: this.repo
            }), orderValues)
                .then(response => {
                    this.eventHub.$emit('game-library-updated', response.data.data.library);
                    this.orderManagementState = false;
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error);
                    this.eventHub.$emit('submit-finish');
                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                });
        },

        orderManagementCancel() {
            this.library = this.orderManagementLibraryCopy;
            this.orderManagementLibraryCopy = [];
            this.orderManagementState = false;
        },

        addArea() {
            this.eventHub.$emit('game-library-add-area');
        },

        assignGame(identifier, setId = null) {
            this.$bvModal.hide('select-games-to-assign-modal');
            this.eventHub.$emit('game-library-add-game', identifier, setId);
        },

        assignGameModal(identifier) {
            this.$bvModal.hide('select-games-to-assign-modal');
            this.eventHub.$emit('game-library-add-game', identifier, this.assignGameSetId);
        },

        assignManyGames() {
            this.$bvModal.hide('select-games-to-assign-modal');
            this.eventHub.$emit('game-library-assign-games', this.selectedGamesToAssign);
        },

        assignManyGamesModal() {
            this.$bvModal.hide('select-games-to-assign-modal');
            this.eventHub.$emit('game-library-assign-games', this.selectedGamesToAssignModal, this.assignGameSetId);
        },

        selectGameToAssignModalHandleHide() {
            this.assignGameSetId = null;
            this.selectedGamesToAssignModal = [];
        },

        approveElementModalHandleOk() {
            this.eventHub.$emit('processing-start');
            if (this.elementToApprove.type === 'area' || this.elementToApprove.type === 'package' || this.elementToApprove.type === 'game') {
                axios.put(route('game::game-library.approve-element', {
                    repo: this.repo,
                    type: this.elementToApprove.type,
                    id: this.elementToApprove.id
                }))
                    .then(response => {
                        this.eventHub.$emit('game-library-updated', response.data.data.library);
                        this.repoUpdate = response.data.data.repoUpdate;
                        this.$bvModal.hide('approve-element-modal');
                        this.elementToApprove = null;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        console.log(error.response);
                        this.eventHub.$emit('processing-finish');
                        if (error.response.data.message) {
                            this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                        }
                    });
            } else if (this.elementToApprove.type === 'menu') {
                axios.post(route('game::game-library.approve-menu', {
                    repo: this.repo
                }))
                    .then(response => {
                        this.menu = response.data.data.menu;
                        this.$bvModal.hide('approve-element-modal');
                        this.elementToApprove = null;
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.data.message, 'success');
                    })
                    .catch(error => {
                        this.eventHub.$emit('processing-finish');
                        if (error.data.message) {
                            this.eventHub.$emit('toast-notification', error.data.message, 'error');
                        } else {
                            this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                        }
                    });
            }
        },

        approveElementModalHandleHide() {
            this.elementToApprove = null;
        },

        addGameToIgnored(identifier) {
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.add-game-to-ignored'), {
                input_identification_name: identifier
            })
                .then(response => {
                    this.rawGames = response.data.data.rawGames;
                    this.ignoredGames = response.data.data.ignoredGames;
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                });
        },

        removeGameFromIgnored(identifier) {
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.remove-game-from-ignored'), {
                input_identification_name: identifier
            })
                .then(response => {
                    this.rawGames = response.data.data.rawGames;
                    this.ignoredGames = response.data.data.ignoredGames;
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                });
        },

        updateDevRepository() {
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.update-dev-repository'))
                .then(response => {
                    this.eventHub.$emit('game-library-updated', response.data.data.library);
                    this.repoUpdate = response.data.data.repoUpdate;
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    if (error.response.data.message) {
                        this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                    } else {
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    }
                });
        },

        updateProdRepoModalHandleOk(event) {
            event.preventDefault();
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.update-prod-repository'))
                .then(response => {
                    this.repoUpdate = response.data.data.repoUpdate;
                    this.$bvModal.hide('update-prod-repo-modal');
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    if (error.response.data.message) {
                        this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                    } else {
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    }
                });
        },

        synchronizeLangRepository() {
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.synchronize-lang-repository'))
                .then(response => {
                    this.eventHub.$emit('game-library-updated', response.data.library);
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    if (error.response.data.message) {
                        this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                    } else {
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    }
                });
        },

        updateRemoteLangRepository() {
            this.eventHub.$emit('processing-start');
            axios.post(route('game::game-library.update-lang-repository'))
                .then(response => {
                    this.repoUpdate = response.data.data.repoUpdate;
                    this.eventHub.$emit('processing-finish');
                    this.eventHub.$emit('toast-notification', response.data.message, 'success');
                })
                .catch(error => {
                    console.log(error.response);
                    this.eventHub.$emit('processing-finish');
                    if (error.response.data.message) {
                        this.eventHub.$emit('toast-notification', error.response.data.message, 'error');
                    } else {
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak.', 'error');
                    }
                });
        },

        approveMenu() {
            if (this.menu.translations_were_updated_since_last_approve) {
                this.eventHub.$emit('game-library-show-approve-menu-modal', this.menu);
            } else {
                this.eventHub.$emit('game-library-approve-element', 'menu', {
                    display_name: 'Menu',
                    id: null,
                    approved_at: (new Date(this.menu.approved_at)).toLocaleString(),
                    files_updated_at: (new Date(this.menu.files_updated_at)).toLocaleString(),
                    files_were_updated_since_last_approve: this.menu.files_were_updated_since_last_approve,
                    config_was_updated_since_last_approve: false,
                    updated_at: null
                });
            }
        },

        showMenuChangelog() {
            this.eventHub.$emit('game-library-show-element-changelog', 'menu', {
                display_name: 'Menu',
                id: null
            });
        },

        toggleNotAssignedGamesExpand() {
            this.notAssignedGamesExpand = !this.notAssignedGamesExpand;
        },

        toggleAssignedGamesExpand() {
            this.assignedGamesExpand = !this.assignedGamesExpand;
        },

        toggleIgnoredGamesExpand() {
            this.ignoredGamesExpand = !this.ignoredGamesExpand;
        },

        showManageTagsModal() {
            this.eventHub.$emit('game-library-show-manage-tags-modal');
        },

        showGameAssignmentManagementModal() {
            this.$bvModal.show('game-assignment-management-modal');
        }

    }

}
</script>

<style scoped>
.game-library-wrapper {
    overflow-x: auto;
}

.game-library {
    min-width: 660px;
    border-top: 1.5px solid #e5e5e5;
}

/deep/ .game-library .element.top-element {
    border-left: 1.5px solid #e5e5e5;
    border-right: 1.5px solid #e5e5e5;
}

/deep/ .game-library .element.nested-element {
    border-left: 1.5px solid #e5e5e5;
}

/deep/ .game-library .element>.element-heading {
    display: flex;
    align-items: center;
    border-bottom: 1.5px solid #e5e5e5;
}

/deep/ .game-library .element>.element-heading .collapse-icon {
    padding: 10px 0;
    width: 40px;
    display: inline-block;
    text-align: center;
}

/deep/ .game-library .element>.element-heading .element-name {
    padding: 10px 10px 10px 0;
    left: -5px;
    position: relative;
    display: flex;
    align-items: center;
}

/deep/ .game-library .element>.element-heading .element-name .display-name {
    margin-right: 5px;
}

/deep/ .game-library .element>.element-heading .element-name .output-identification-name {
    font-size: 80%;
    font-weight: 400;
    margin-right: 15px;
    padding-top: 2px;
}

/deep/ .game-library .element>.element-heading .element-name .badge.badge-pill {
    font-size: 0.625rem;
    margin-right: 4px;
}

/deep/ .game-library .element>.element-heading .element-buttons {
    padding-right: 10px;
    margin-left: auto;
    display: flex;
    align-items: center;
}

/deep/ .game-library .element>.element-heading .element-buttons .buttons-row {
    display: flex;
    align-items: center;
}

/deep/ .game-library .element>.element-heading .element-buttons .buttons-row .btn.btn-xs {
    padding: 0.3rem 0.5rem;
    font-size: 0.625rem;
    margin-left: 4px;
}

/deep/ .game-library .element>.element-heading .element-buttons>.buttons-row>a.up {
    right: 50px;
    margin-top: -2px;
    font-size: 125%;
    margin-right: 5px;
}

/deep/ .game-library .element>.element-heading .element-buttons>.buttons-row>a.down {
    right: 25px;
    margin-top: -1px;
    font-size: 125%;
}

/deep/ .game-library .element>.element-heading .element-text {
    display: inline-block;
    padding: 10px;
    position: relative;
}

/deep/ .game-library .element>.element-heading .element-text.disabled,
.not-assigned-games>.not-assigned-game.disabled {
    cursor: not-allowed !important;
}

/deep/ .game-library .element>.element-heading .element-text.disabled a,
.not-assigned-games .not-assigned-game.disabled>a {
    color: #79aae5 !important;
    pointer-events: none;
}

/deep/ .not-assigned-games .not-assigned-game a.assign {
    font-size: 150%;
    position: absolute;
    right: 50px;
}

/deep/ .assigned-games .assigned-game a.assign {
    font-size: 150%;
    position: absolute;
    right: 21px;
}

/deep/ .not-assigned-games .not-assigned-game a.ignore {
    font-size: 150%;
    position: absolute;
    right: 22px;
}

/deep/ #select-games-to-assign-modal .not-assigned-games .not-assigned-game a.assign {
    right: 38px;
}

/deep/ .ignored-games .ignored-game a.restore {
    font-size: 125%;
    position: absolute;
    right: 22px;
}

/deep/ .game-library .element.last-element>.element-heading .element-name {
    padding: 10px;
    left: 0;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/deep/ .game-library .element.last-element>.element-heading .element-name small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/deep/ .game-library .element.nested-element {
    margin-left: 40px;
}

/deep/ .game-library .element.expanded {
    border-bottom: 1.5px solid #e5e5e5;
}

/deep/ .game-library .element.nested-element.repo-dev:last-child>.element-heading {
    border-bottom: none;
}

/deep/ .game-library .element.nested-element.expanded:not(.repo-dev):last-child {
    border-bottom: none;
}

/deep/ .game-library .element.nested-element.collapsed:not(.repo-dev):last-child>.element-heading {
    border-bottom: none;
}

/deep/ .game-library .element.nested-element.last-element:not(.repo-dev):last-child>.element-heading {
    border-bottom: none;
}

/deep/ .game-library .yellow,
.caption-color-block.yellow {
    background: #fdffd7;
}

/deep/ .game-library .green,
.caption-color-block.green {
    background: #e6ffe4;
}

/deep/ .game-library .blue,
.caption-color-block.blue {
    background: #ebf4ff;
}

/deep/ .game-library .white,
.caption-color-block.white {
    background: #ffffff;
}

.caption-title {
    display: inline-block;
    font-size: 0.875rem;
    padding: 4px 0px;
}

.caption-color-block {
    display: inline-block;
    margin-left: 5px;
    font-size: 0.875rem;
    padding: 4px 8px;
    border: 1.5px solid #e5e5e5;
}

.menu-block {
    border: 1.5px solid #e5e5e5;
    background: #c3fff7;
}

.menu-block .menu-title {
    border-right: 1.5px solid #e5e5e5;
    padding: 10px;
    width: 62px;
    vertical-align: middle;
}

.menu-block .menu-dates {
    padding: 10px;
}

.menu-block .menu-first-date {
    padding-right: 20px;
}

.menu-block .menu-buttons {
    padding-right: 10px;
    vertical-align: middle;
}

.menu-block .menu-buttons .buttons-row {
    display: flex;
    align-items: center;
    justify-content: right;
}

.menu-block .menu-buttons .buttons-row .btn.btn-xs {
    padding: 0.3rem 0.5rem;
    font-size: 0.625rem;
    margin-left: 4px;
}

.actions-table {
    width: 100%;
}

.actions-table th,
.actions-table td {
    vertical-align: top;
    width: 33.33%;
}

.actions-table td ol {
    margin-bottom: 0;
}

.actions-table td ol li {
    line-height: 1;
}

.actions-table td ol li:not(:last-child) {
    margin-bottom: 8px;
}

.not-assigned-games-heading,
.assigned-games-heading {
    font-size: 1.25rem;
    cursor: pointer;
}

.not-assigned-games-heading i,
.assigned-games-heading i {
    margin-right: 6px;
    top: 1px;
    position: relative;
}

.not-assigned-games,
.assigned-games {
    border: 1.5px solid #e5e5e5;
}

.not-assigned-games .not-assigned-game {
    padding: 10px 54px 10px 10px;
    display: flex;
    align-items: center;
}

.assigned-games .assigned-game {
    padding: 10px 35px 10px 10px;
    display: flex;
    align-items: center;
}

.not-assigned-games .not-assigned-game:not(:last-child),
.assigned-games .assigned-game:not(:last-child) {
    border-bottom: 1.5px solid #e5e5e5;
}

.not-assigned-games .not-assigned-game div,
.assigned-games .assigned-game div {
    flex: 1;
    min-width: 0;
}

.not-assigned-games .not-assigned-game .custom-control-label,
.assigned-games .assigned-game .custom-control-label {
    display: inline;
    position: absolute;
}

.not-assigned-games .not-assigned-game .checkbox-text,
.assigned-games .assigned-game .checkbox-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    margin-bottom: 0;
    vertical-align: top;
}

.not-assigned-games .not-assigned-game a,
.assigned-games .assigned-game a {
    margin-left: auto;
}

.ignored-games-heading {
    font-size: 1.25rem;
    cursor: pointer;
}

.ignored-games-heading i {
    margin-right: 6px;
    top: 1px;
    position: relative;
}

.ignored-games {
    border: 1.5px solid #e5e5e5;
}

.ignored-games .ignored-game {
    padding: 10px;
    display: flex;
    align-items: center;
}

.ignored-games .ignored-game:not(:last-child) {
    border-bottom: 1.5px solid #e5e5e5;
}

.ignored-games .ignored-game div {
    flex: 1;
    min-width: 0;
}

.ignored-games .ignored-game .ignored-game-text {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    margin-bottom: 0;
    vertical-align: top;
}

.ignored-games .ignored-game a {
    margin-left: auto;
}
</style>
